package com.parmartechnologies.storage.table.media_file

import com.parmartechnologies.core.feature.mediaFile.model.MediaFile
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.constant.KeyConstant.Companion.id
import com.parmartechnologies.storage.table.DatabaseTable

class MediaFileDatabaseTable : DatabaseTable() {
    fun insert(item: MediaFile?, callback: () -> Unit) {
        item?.let {
            DatabaseCollection().insert(item, MediaFile.serializer())
        }
        callback()
    }
    fun insert(item: MediaFile?) {
        item?.let {
            DatabaseCollection().insert(item, MediaFile.serializer())
        }
    }

    fun insert(items: List<MediaFile>?, callback: () -> Unit) {
        items?.let {
            DatabaseCollection().insertAll(items, MediaFile.serializer())
        }
    }

    fun retrieve(id: String, callback: (List<MediaFile>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, MediaFile.serializer()){
            callback(it)
        }
    }

    fun find(id: String, callback: (MediaFile?) -> Unit) {
        val query = mapOf(Pair("feature_object_id",id))
        DatabaseCollection().findOne(query, MediaFile.serializer()){
            callback(it)
        }
    }

    fun findBy(featureId: String, callback: (MediaFile?) -> Unit) {
        val query = mapOf(Pair("feature_object_id",featureId))
        DatabaseCollection().findOne(query, MediaFile.serializer()){
            callback(it)
        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
        callback("")
    }
}